import React from "react";
import { styled } from "@mui/material/styles";
import Menu from "./components/Menu";
import TeamDropdown from "../../components/DropDowns/TeamDropdown";
import Notifications from "./components/Notifications";
import { useSelector } from "react-redux";
import { FlexWrapper, NavBarContainer } from "../../StyledComponents";
import { selectDashPerspective, selectNavSelection, selectPageSelection, selectRunningSweep } from "../../slices/sessionDataSlice";
 
const NavBar = () => {

  const navSelection = useSelector(selectNavSelection)
  const runningSweep = useSelector(selectRunningSweep)
  const pageSelection = useSelector(selectPageSelection)
  const dashPerspective = useSelector(selectDashPerspective)
  
  return (
    <DashboardTopBar>
      {dashPerspective && navSelection === 'investigations' && pageSelection === 'dashboard' && !runningSweep ?
        <PerspectiveSlot className="alignCenter justifyCenter">
          <TeamDropdown dashPerspective={dashPerspective} />
        </PerspectiveSlot>
      :
        <></>
      }
      <ActionSlot className="justifyCenter">
        <Notifications runningSweep={runningSweep} />
        <Menu runningSweep={runningSweep} />
      </ActionSlot>
    </DashboardTopBar>
  )
}

const DashboardTopBar = styled(NavBarContainer)({
  background:
    "linear-gradient(180deg, rgba(255,255,255,0.9), rgba(239,244,249,0.78))",
  borderBottom: "0.1rem solid rgba(120,139,158,0.24)",
  boxShadow: "0 0.8rem 1.8rem rgba(71,85,105,0.08)",
  backdropFilter: "blur(12px)",
});

const PerspectiveSlot = styled(FlexWrapper)({
  gridColumn: 1,
});

const ActionSlot = styled(FlexWrapper)({
  gridColumn: 2,
});

export default NavBar;